import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 498C-1 817 203 999 498 1000C793 1001 999 817 1000 498C1001 207 793 1 498 0C202 -1 1 207 0 498ZM82 500C82 255 255 83 498 83C741 83 918 255 918 500C918 764 741 917 498 917C255 917 82 764 82 500ZM359 692V304H451V692ZM549 692V304H641V692Z" })
});
export default SvgPauseIcon;
